import { userConstants } from "../constants/user.constants";
import { userService } from "../services/user.service";
import { alertActions } from "./alert.actions";
import { history } from "../helpers/history";
import jwt from 'jwt-decode';
import {modalActions} from "./modal.actions";
import {toastr} from 'react-redux-toastr'
import i18next from "i18next";

const login = (username, password, validateError = function() {} ) => {
    return dispatch => {
        dispatch(request({ username }));
        userService.login(username, password)
            .then(
                user => {
                    console.log(user);
                    dispatch(success(jwt(user.token)));
                    toastr.info(i18next.t('authorization'), i18next.t('msg.loggin', { user: username }));
                    history.push('/panel');
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                    validateError(error.response)
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user} }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user} }
    function failure(error) { return {type: userConstants.LOGIN_FAILURE, error} }
};

const logout = () => {
    userService.logout();
    history.push('/login');
    return {type: userConstants.LOGOUT }
};

const getUserList = () => {
    return dispatch => {
        userService.getList()
            .then(
                userModel => {
                    dispatch({ type: userConstants.USER_LIST_SUCCESS, userModel })
                },
                error => {
                    dispatch({ type: userConstants.USER_LIST_FAILURE, error })
                }
            )
    }
};

const getUserById = (id) => {
    return dispatch => {
        userService.getById(id)
            .then(
                userModel => {
                    dispatch({type: userConstants.USER_GET_BY_ID_SUCCESS, userModel});
                },
                error => {
                    dispatch({ type: userConstants.USER_GET_BY_ID_FAILURE, error })
                }
            )
    }
};

const resetPassword = (userId) => {
    return dispatch => {
        userService.resetPassword(userId)
            .then(
                () => dispatch(getUserList()),
                (error) => console.log(error)
            )
    }
};

const changePassword = (changePasswordModel) => {
    return dispatch => {
        userService.changePassword(changePasswordModel)
            .then(
                () => {
                    toastr.info(i18next.t('authorization'), i18next.t('msg.change-password', { user: changePasswordModel.email }));
                },
                (error) => {
                    // todo: validation
                    toastr.error('error', error.toString())
                }
            )
    }
}

const editProfileDetails = (profileDetailsModel) => {
    return dispatch => {
        userService.editUser(profileDetailsModel)
            .then(
                () => {
                    toastr.info(i18next.t('user-details'), i18next.t('msg.user-details-edit-done'));
                },
                (error) => {
                    // todo: validation error
                    toastr.error('error', error.toString())
                }
            )
    }
}

const activateUser = (userId) => {
    return dispatch => {
        userService.activateUser(userId)
            .then(
                () => dispatch(getUserList()),
                (error) => console.log(error)
            )
    }
};

const deactivateUser = (userId) => {
    return dispatch => {
        userService.deactivateUser(userId)
            .then(
                () => dispatch(getUserList()),
                (error) => console.log(error)
            )
    }
};

const createUser = (createModel) => {
    return dispatch => {
        userService.createUser(createModel)
            .then(
                () => {
                    dispatch(getUserList());
                    dispatch(modalActions.hideModal());
                },
                (error) => console.log(error)
            )
    }
};

const editUser = (editModel) => {
    return dispatch => {
        userService.editUser(editModel)
            .then(
                () => {
                    dispatch(getUserList());
                    dispatch(modalActions.hideModal())
                },
                (error) => console.log(error)
            )
    }
};

const clearUserById = () => {
    return dispatch => {
        dispatch({type: userConstants.USER_GET_BY_ID_CLEAR})
    };
};

export const userActions = {
    login,
    logout,
    getUserList,
    getUserById,
    createUser,
    editUser,
    editProfileDetails,
    clearUserById,
    resetPassword,
    activateUser,
    deactivateUser,
    changePassword
};
